import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const selectA11yPageTitle = createSelector(
    (state: RootState) => state.currentPage,
    (state: RootState) => state.ui.debug,
    (currentPage, debug) => {
        const { title, a11yTitle } = currentPage;

        if (debug.a11yDevToolEnabled && !debug.a11yContextSpecificPageTitleAnnouncementsEnabled) {
            return title?.replace('|', '-') || '';
        }

        return [title, a11yTitle].filter(Boolean).join(', ').replace('|', '-');
    },
);

const selectA11yAnnouncement = (state: RootState) => state.currentPage.a11yAnnouncement;

const selectGaPageTypeName = (state: RootState) => state.currentPage.gaPageTypeName;

export const currentPageSelectors = {
    selectA11yPageTitle,
    selectA11yAnnouncement,
    selectGaPageTypeName,
};
